import React, { useEffect, useState } from "react";
import api from "utils/api";
import Loader from "Components/Loader";
import { message } from "antd";
import PatientDetailsAllChild from "./PatientDetailsAllChild";
function PatientDetailsAll(props) {
  const [alldata, setAllData] = useState([]);
  const [load, setLoader] = useState(true);
  const allDataGet = () => {
    api
      .all_form_summary({ patient_id: props?.data?.patient_id })
      .then((response) => {
        if (response.data?.status === 200) {
          setAllData(response?.data?.data?.results);
          // setAllData(dataset())
          // message.success(response.data?.message);
          setLoader(false);
        } else {
          setLoader(false);
          message.error(response.data?.message);
        }
      })
      .catch((err) => {
        setLoader(false);
        message.error("Something went wrong");
      });
  };
  useEffect(() => {
    allDataGet();
  }, []);
  return (
    <>
      {load ? (
        <Loader />
      ) : (
        <div className="patientDetailsAll">
          <PatientDetailsAllChild
            value={props?.data}
            records={alldata}
          />
        </div>
      )}
    </>
  );
}
function dataset(){
  return([
    {
      "date": "2024-03-27 17:14:21",
      "consultation_doctor": "Balaji",
      "doctor_last_name": "",
      "doctor_salutation": "Dr",
      "vital": [
          {
              "patient_id": 13,
              "vital_id": 6,
              "required_vitals": [
                  {
                      "max": "145/90",
                      "min": "45/30",
                      "unit": "mmHg",
                      "label": "BP",
                      "value": "92/65",
                      "choices": null,
                      "field_value": "blood_pressure",
                      "is_changeable": true
                  },
                  {
                      "max": "170",
                      "min": "60",
                      "unit": "beats pm",
                      "label": "Pulse rate",
                      "value": "72",
                      "choices": null,
                      "field_value": "pulse_rate",
                      "is_changeable": true
                  },
                  {
                      "max": "115.7",
                      "min": "98.6",
                      "unit": "ºF",
                      "label": "Temp",
                      "value": "98.8",
                      "choices": null,
                      "field_value": "temperature",
                      "is_changeable": true
                  },
                  {
                      "max": "100",
                      "min": "50",
                      "unit": "%",
                      "label": "SPO2",
                      "value": "82",
                      "choices": null,
                      "field_value": "spo2",
                      "is_changeable": true
                  },
                  {
                      "max": "30",
                      "min": "8",
                      "unit": "breaths pm",
                      "label": "Respiratory rate",
                      "value": "26",
                      "choices": null,
                      "field_value": "respiratory_rate",
                      "is_changeable": true
                  },
                  {
                      "max": "500",
                      "min": "60",
                      "unit": "mg/dL",
                      "label": "Blood Glucose",
                      "value": "102",
                      "choices": null,
                      "field_value": "blood_glucose",
                      "is_changeable": true
                  },
                  {
                      "max": null,
                      "min": null,
                      "unit": null,
                      "label": "Blood Group",
                      "value": "O+",
                      "choices": [
                          "A+",
                          "A-",
                          "B+",
                          "B-",
                          "O+",
                          "O-",
                          "AB+",
                          "AB-"
                      ],
                      "field_value": "blood_group",
                      "is_changeable": true
                  },
                  {
                      "max": "272",
                      "min": "55",
                      "unit": "cm",
                      "label": "Height",
                      "value": "173",
                      "choices": null,
                      "field_value": "height",
                      "is_changeable": true
                  },
                  {
                      "max": "200",
                      "min": "2",
                      "unit": "Kg",
                      "label": "Weight",
                      "value": "84",
                      "choices": null,
                      "field_value": "weight",
                      "is_changeable": true
                  },
                  {
                      "max": null,
                      "min": null,
                      "unit": null,
                      "label": "BMI",
                      "value": 28.07,
                      "choices": null,
                      "field_value": "bmi",
                      "is_changeable": true
                  }
              ],
              "others": [],
              "is_submitted": true,
              "is_saved": false,
              "is_editable": true,
              "comment": "",
              "created_on": "2024-04-22 15:46:08",
              "updated_on": "2024-05-09 11:55:54",
              "created_by": "Muthuvel E",
              "updated_by": "Muthuvel E",
              "is_vital_eligible": true
          }
      ],
      "prescription": [
          {
              "app_id": 378,
              "app_date_time": "2024-04-26 16:30:00",
              "clinical_diagnosis": "Typhoid fever and unspecified(A0100)",
              "comorbidities": [
                  "NIL"
              ],
              "ayurveda": {},
              "allopathy": {
                  "medicines": [
                      {
                          "form": "Powder",
                          "type": "allopathy",
                          "route": "Oral",
                          "dosage": "50 mg",
                          "drug_id": 63,
                          "form_id": 1,
                          "adjuvant": "",
                          "brand_id": 70,
                          "duration": "10 Day(s)",
                          "drug_name": "Pregabalin",
                          "frequency": "1-0-2-0",
                          "brand_name": "Zipsydon",
                          "instruction": "",
                          "is_allergic": false,
                          "medicine_id": 63
                      }
                  ],
                  "completion_date": "2024-04-26 16:40:56",
                  "is_completed": true
              },
              "consultation_doctor": "Disha",
              "doctor_last_name": "",
              "doctor_salutation": "Dr",
              "is_prescription_required": true,
              "comments": "",
              "medical_test": {}
          }
      ],
      "diagnosis": [
          {
              "is_completed": true,
              "completion_date": "2024-04-26 16:30:00",
              "updated_date": "2024-04-26 16:40:30",
              "consultation_doctor": "Disha",
              "doctor_last_name": "",
              "doctor_salutation": "Dr",
              "finding_from_dsm": [],
              "provisional_diagnosis": [
                  "Typhoid fever and unspecified(A0100)"
              ],
              "differential_diagnosis": [],
              "final_diagnosis": [],
              "final_diagnosis_check_box": []
          }
      ],
      "case_notes": [
          {
              "appointment_id": 378,
              "consultation_date": "2024-04-26 16:30:00",
              "consultation_doctor": "Disha",
              "doctor_last_name": "",
              "doctor_salutation": "Dr",
              "notes": "Adding case not for DEPENDENT",
              "is_editable": false
          }
      ]
    }
  ])
}
export default PatientDetailsAll;
